import React, {Component} from 'react';
import {Button, Form, Header, Icon, Modal} from 'semantic-ui-react';
import AccountRemittanceContainer from "../../../containers/account_remittance_container";

class RemittanceAdjustment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: true,
            message: undefined
        }
    }

    handleAssignment = (e) => {
        const formData = new FormData(e.target);
        if (this.props.adjustment.length > 0) {
            this.props.updateAdjustment(formData, "update", this.onSuccessCallBack, this.props.estimateId)
        }
        else {
            this.props.updateAdjustment(formData, "create", this.onSuccessCallBack, this.props.estimateId)
        }
    };

    onSuccessCallBack = (response) => {
        this.props.alertMessage(response);
    };

    render() {
        const adjustment = this.props.adjustment[0];
        return (
            <div>
                <Modal size="tiny" open={this.state.show} onClose={(e) => {
                    this.setState({show: false});
                    this.props.close(false);
                }}>
                    <Modal.Content>
                        <Header textAlign='center' size='large'>Adjustment<span className="pull-right icon-button"><Icon
                            name="close" size="small" color="red" onClick={() => {
                            this.setState({show: false});
                            this.props.close(false);
                        }}/></span></Header>
                        <Modal.Description>
                            <div>
                                <Form onSubmit={this.handleAssignment}>
                                    <input type="hidden" name="remittance_estimate_id" value={this.props.estimateId}/>
                                    <input type="hidden" name="remittance_adjustment_id"
                                           value={adjustment && adjustment['id'] ? adjustment['id'] : undefined}/>
                                    <Form.Input
                                        label="Adjustment Notes"
                                        name="description"
                                        required
                                        defaultValue={adjustment && adjustment['description'] ? adjustment['description'] : undefined}
                                    />
                                    <Form.Input
                                        label="Adjustment Amount"
                                        name="amount"
                                        required
                                        defaultValue={adjustment && adjustment['amount'] ? adjustment['amount'] : 0}
                                    />
                                    <div className="pull-right pad-all">
                                        <Button type="submit" primary content="Save"/>
                                    </div>
                                </Form>
                            </div>
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </div>
        )
    }
}

export default AccountRemittanceContainer(RemittanceAdjustment)


// WEBPACK FOOTER //
// ./src/views/accounts/remittance/remittance_adjustment.js